<template>
  <qzf-tabs v-model:value="value" @tab-click="handleClick">
    <qzf-tabs-item label="建账初始化" name="1" :cache="false">
      <initTable ref="initTable" :activeName = "activeName"></initTable>
    </qzf-tabs-item>
    <qzf-tabs-item label="个税初始化" name="2" :cache="false">
      <personalTax></personalTax>
    </qzf-tabs-item>
  </qzf-tabs>
  <!-- <div class="app-container">
    <initTable ref="initTable" :activeName = "activeName"></initTable>
  </div> -->
</template>

<script>
import initTable from "./components/initTable.vue"
import personalTax from "./components/personalTax.vue"
export default {
  name:'kjInit',
  components:{
    initTable,
    personalTax
  },
  data(){
    return {
      activeName:'first',
      value:'1',
      listQuery: {
        page: 1,
        limit: 20,
        setUpStatusCj:[1],
        from:'init'
      },
    }
  },
  methods:{
    // handleClick(tab, event) {
    //   if (tab.props.label == "已采集") {
    //     this.listQuery.setUpStatusCj = [1]
    //     this.tabName = tab.props.name
    //     this.$refs.initTable.getList()
    //   } else if (tab.props.label == "跳过采集") {
    //     this.tabName = tab.props.name
    //     this.listQuery.setUpStatusCj = [2]
    //     this.$refs.initTable.getList()
    //   } 
    // },
  }
}
</script>

<style lang="scss" scoped>

</style>